module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment05_sp-f5b980ef20541bb8f18e30366fbce4c9.png";